module.exports = __webpack_public_path__ + "static/media/Peak-End Rule.1403a165.jpg";